export interface ZipCodeResult {
    address1: string
    address2: string
    address3: string
    kana1: string
    kana2: string
    kana3: string
    prefcode: string
    zipcode: string
}

export interface ZipCodeResponse {
    status: number
    message: string | null
    results: ZipCodeResult[] | null
}

export type ApiResponseError =
    | {
          status: number
          message: string
      }
    | Error

export const zipCodeError = (message): ApiResponseError => ({
    status: 400,
    message: message,
})
